export const CURRENCY_SYMBOL: { [key: string]: string } = {
  USD: 'US$',
  EUR: '€',
  GBP: '£',
}
